import { render, staticRenderFns } from "./MovedLessonTeacherDialog.vue?vue&type=template&id=37414568"
import script from "./MovedLessonTeacherDialog.vue?vue&type=script&lang=ts"
export * from "./MovedLessonTeacherDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports